import { memoize } from "@suse-o11y/memoize";
import { prop as prop_ } from "remeda";

const memoizedProp = memoize(prop_);

export const prop: typeof prop_ = (...args: Array<never>) => {
	if (args.length === 1) {
		// memoize the prop function to avoid creating a new function on every render
		return memoizedProp(args[0]);
	}

	return prop_(args[0], args[1]);
};
